module.exports = __webpack_public_path__ + "img/embaixo3.2314fd1f.jpg";